import ColumnChooser from './ColumnChooser.component';

export default ColumnChooser;
